export default {
  needDefinePassword: false,
};
